import ExportPurchaseReport from "./ExportPurchaseReport";
import ExportXLSXUseCase from "./ExportXLSXUseCase";
import ExportSalesReport from "./ExportSalesReport";

export function exportXLSXUseCase() {
  return new ExportXLSXUseCase();
}

export function exportPurchaseReportUseCase() {
  return new ExportPurchaseReport();
}

export function exportSalesReportUseCase() {
  return new ExportSalesReport();
}
